/**
 * @module util/fleqv
 */


function base64ToBinary(base64Text) {
    let binary = atob(base64Text)
    let len = binary.length
    let bytes = new Uint8Array(len)
    for (let i = 0; i < len; i++) {
        bytes[i] = binary.charCodeAt(i)
    }

    return new Blob([bytes.buffer])
}


function apiCall(method, path) {
    return async (baseUrl, { queryParams, body }) => {
        const params = {
            method,
        }

        if (body) {
            params["body"] = body
        }

        const queryString = queryParams ? `?${new URLSearchParams(queryParams)}` : ''

        const req = new Request(`${baseUrl}${path}${queryString}`, params)
        return fetch(req)
    }
}

export default {
    // フォーマット印刷
    formatPrint: apiCall("POST", "/Format/Print"),

    // ステータス取得
    getPrinterStatus: apiCall("GET", "/Printer/Status"),
    getSpoolerStatus: apiCall("GET", "/Spooler/Status"),

    print(printerURL, layoutFileBase64, formatID, params) {
        const apiCaller = apiCall("POST", "/Format/Print")
        const formData = new FormData()

        // スプーラを使わない設定
        formData.append("__check_ready_status", "none")
        formData.append("__status_check_timing", "none")

        formData.append("__format_id_number", formatID)
        formData.append("__format_archive_attach", base64ToBinary(layoutFileBase64))

        Object.entries(params).forEach(([k, v]) => formData.append(k, v))

        return apiCaller(printerURL, {
            body: formData,
        })
    },

    // testPrint(printerURL, formatID, item_cd, nebiki_rate, std_price, price, tax_rate, count) {
    //     const apiCaller = apiCall("POST", "/Format/Print")
    //     const formData = new FormData()

    //     // スプーラを使わない設定
    //     formData.append("__check_ready_status", "none")
    //     formData.append("__status_check_timing", "none")

    //     formData.append("__format_id_number", formatID)
    //     formData.append("__format_archive_attach", base64ToBinary(fleqvLabels.tokyuDemo))

    //     formData.append("元売価", std_price)
    //     formData.append("値引額", nebiki_rate * 100)
    //     formData.append("新価格", price)
    //     // formData.append("新価格(税込)", Math.floor(price * (1 + tax_rate)))
    //     // formData.append("バーコード", `00000000000000000000${item_cd}`.substring(item_cd.length))

    //     // 東急仕様
    //     const barcodeBase = `${item_cd}3${("00000"+price).slice(-5)}`
    //     const barcode = `${barcodeBase}${calcModulus10(barcodeBase)}`
    //     formData.append("バーコード", barcode)

    //     formData.append("(発行枚数)", count)

    //     return apiCaller(printerURL, {
    //         body: formData,
    //     })

        // const apiCaller = apiCall("GET", "/Format/Print")

        // return apiCaller(printerURL, {
        //     queryParams: {
        //         __format_id_number: id,
        //         __format_archive_url: "http://dr.sinops.jp/~t-okuno/test-sato-printer/empty.spproz",
        //         "(発行枚数)": "3",
        //     }
        // })
    // },
}
